export const defaultState = {
  works: [],
};

export default {
  ...defaultState,
};
